import * as React from 'react';

export const ugFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3148)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#FECA00'
            />
            <mask
                id='mask0_55_3148'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3148)'>
                <path
                    d='M0 0H28V4H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#272727'
                />
                <path
                    d='M0 7H28V10H0V7Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M0 4H28V7H0V4Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FECA00'
                />
                <path
                    d='M0 13H28V16H0V13Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FECA00'
                />
                <path
                    d='M0 10H28V13H0V10Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#272727'
                />
                <path
                    d='M0 16H28V20H0V16Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M14 15C16.7614 15 19 12.7614 19 10C19 7.23858 16.7614 5 14 5C11.2386 5 9 7.23858 9 10C9 12.7614 11.2386 15 14 15Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#F7FCFF'
                />
                <path
                    d='M12.8037 6.22195C13.3197 6.22195 13.6332 6.79606 13.6396 6.80789C13.6396 6.80789 12.9514 7.36347 12.9512 7.81766C12.9512 8.27188 12.7145 8.90016 13.6396 9.30594C14.5648 9.71167 16.0504 9.71178 16.2412 10.4485C16.4318 11.185 15.8825 11.4573 15.1299 11.4573C14.3772 11.4573 13.7651 11.1055 14.0713 11.4573C14.3776 11.8092 15.1606 12.6426 14.6162 12.6429C14.4342 12.6429 13.749 12.036 13.7227 12.5452C13.7061 12.8674 14.0324 13.7529 13.7227 14.095C13.6531 14.1765 14.6419 14.3429 14.5645 14.4173C14.3661 14.6072 13.9818 14.4174 13.4629 14.4173C13.3971 14.4173 12.5242 15.0042 12.4346 15.0003C12.3497 14.9958 13.0243 14.4275 12.9512 14.4173C12.5061 14.3696 11.9922 14.4656 11.9727 14.4173C11.9385 14.3325 13.0995 14.4408 13.3467 14.095C13.7352 13.5501 13.2889 12.4957 13.2393 12.4876C12.6248 12.4242 12.0261 12.412 11.8828 12.6429C11.6111 13.0819 11.0303 13.5225 11.0303 13.302C11.0299 13.0812 10.7176 12.4036 12.1094 12.4036C13.5016 12.4036 13.2578 12.2346 13.2578 12.2346V11.6585C13.2578 11.6585 11.1543 11.1092 11.1543 9.89676C11.1543 8.68435 12.1022 8.09649 12.2334 7.81766C12.3646 7.53882 12.2334 7.18192 12.2334 7.18192L11.4219 7.10477L12.2334 6.80789C12.2345 6.79589 12.288 6.22209 12.8037 6.22195ZM13.6523 12.1429C13.6692 12.1478 14.1973 12.3002 14.0869 12.0042C13.9762 11.7087 13.6645 11.7138 13.6523 11.7141V12.1429Z'
                    fill='#272727'
                />
                <path
                    d='M11.7714 5.42734L12.5491 6.45354L12.9518 6.34814L12.7587 5.31219L11.7714 5.42734Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M12.7811 5.17915L12.8312 6.72199L13.4953 6.54016L13.7781 5.52969L12.7811 5.17915Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FFD018'
                />
                <path
                    d='M12.1551 7.75615C12.3018 7.75615 12.4207 7.62714 12.4207 7.46799C12.4207 7.30885 12.3018 7.17984 12.1551 7.17984C12.0084 7.17984 11.8895 7.30885 11.8895 7.46799C11.8895 7.62714 12.0084 7.75615 12.1551 7.75615Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M13.8428 5.46821L13.0696 6.49863L13.2328 6.92167L14.1161 6.53012L13.8428 5.46821Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M15.64 13.2666C15.64 13.2666 17 12.5906 17 11.6452C17 10.6998 14.7917 9.66998 14.7917 9.66998C14.7917 9.66998 13.4927 10.0008 14.0782 10.4435C14.6637 10.8862 15.4482 11.0563 15.4482 11.6452C15.4482 12.2341 15.6631 12.7957 15.2274 12.7957C14.7917 12.7957 15.64 13.2666 15.64 13.2666Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#D74800'
                />
                <path
                    d='M13.6778 9.49716C13.6778 9.49716 13.1968 9.59118 13.2197 9.67811C13.2828 9.91843 13.9405 10.2314 14.2271 10.4482C14.8126 10.8909 15.3677 10.8411 15.7807 10.553C16.1937 10.2649 13.6778 9.49716 13.6778 9.49716Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FFFDFF'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3148'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
